module.exports = __webpack_public_path__ + "img/饶阳蔬菜.72afa9a9.jpg";